import { Component, OnInit ,ViewChild} from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';  

@Component({
  selector: 'app-servicios',
  templateUrl: './servicios.component.html',
  styleUrls: ['./servicios.component.scss']
})
export class ServiciosComponent implements OnInit {

  @ViewChild('cper',null) cper;
  @ViewChild('cper2',null) cper2;
  
  @ViewChild('craci',null) craci;
  @ViewChild('cpro',null) cpro;
  @ViewChild('cprol',null) cprol;
  @ViewChild('cpa',null) cpa;
  @ViewChild('cdep',null) cdep;
  

  constructor(
    public authService: AuthService,
    public router: Router) {      
    }
    procesos=[{id:0,proceso:"",descripcion:"",idx:0,valor:0,valor_:"",raci2:0}];
  area=[{id:0, area:"",idx:0,id_ant:0}];
  rel_pa=[{id:0,id_p:0,id_a:0,rol:"",c:""} ];
id_raci:Number=0
  ngOnInit() {
    this.id_cliente=Number(localStorage.getItem("id_cliente"));
    this.ls_raci();
    this.get_org();    
    this.sel_raci();
  }
  bndmnugral=true;
    oculta_menu(){
      console.log("-");
      if(this.bndmnugral==true){
        this.bndmnugral=false;
      }else{
        this.bndmnugral=true;
      }
      console.log(this.bndmnugral);
    }
    _go(a){
      //localStorage.setItem("menu_","1");    
      this.router.navigate([a]);
    }
  sel_raci(){
    this.raci_list=[];
    try {
      for(var i=0;i<this.raci.length;i++){
      if(this.org_id==this.raci[i].id_org)
      this.raci_list.push(this.raci[i]);
    }
    } catch (error) {      
    }
    
  }
  org;
  raci_list;
  org_;
  org_id=-1;
  org_id2=-1;
  get_org(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    } 
      //console.log(postData);
      this.authService.service("/api/get_org_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            this.org=data;
            //this.org_=this.authService.org_head(this.org);
            this.org_=this.authService._org_jerarquizacion(data);
            console.log(this.org_);
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
    }
  btn_dep:boolean=true;
  btn_pro:boolean=true;
  id_pro:Number=0;
  id_dep:Number=0;
  upd_proceso_lado(itm){
    console.log(itm);
    this.id_pro=itm.id;
    this.pro_="";
    this.des_="";
  }
  upd_proceso(itm){  
    this.vdel_pro=true; 
    this.btn_pro=false; 
    //console.log(itm);
    this.id_pro=itm.id;
    this.pro_=itm.proceso;
    this.des_=itm.descripcion;
  }

  vdel_area:boolean=true;
  vdel_dep_(){
    this.vdel_area=false;
  }
  can_dep(){
    this.vdel_area=true;
  }

  _area2(itm){
    this.id_dep=itm.id;
    this.dep_="";
  }
  upd_area(itm){    
    this.vdel_area=true;
    this.btn_dep=false;
    console.log(itm);
    this.id_dep=itm.id;
    this.org_id_=itm.id_ant;
    this.dep_=itm.area;
  }
  dupl_raci(itm){
    if(confirm("Confirm to copy this RACSI?")==false)return;
    let postData = {
      id_raci:itm.id
    }
    this.procesos=[];
    console.log(postData);
    this.authService.service("/api/copy_raci",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                      
        this.update_raci();
        this.ls_raci();
        this.cper.nativeElement.click();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      }); 
  }
  upd_dep(){
    let postData = {
      dep:this.dep_,
      id:this.id_dep,
      id_ant:this.org_id_
    }
    //this.procesos=[];
    this.t_memo="upd";
    this.ap_memo="area";
    this.authService.service("/api/upd_dep",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                      
        //this.update_raci();
        this.memoria();
        this.cdep.nativeElement.click();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      }); 
  }
  vdel_pro:boolean=true;
  can_pro(){
    this.vdel_pro=true;
  }
  vdel_pro_(){
    this.vdel_pro=false;
  }
  del_dep(){
    
    this.t_memo="del";
    this.ap_memo="area";
    let postData = {
      id:this.id_dep
    }
    this.authService.service("/api/del_dep",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                      
        //this.update_raci();
        this.memoria();
        this.cdep.nativeElement.click();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      }); 
  }
  public loading;
  mov_idx(itm,t){
    this.t_memo="mov";
    this.ap_memo="pro";
    this.id_pro=itm.id;
    this.lado=t;


    this.loading=true;
    let postData = {      
      lado:t,     
      id:itm.id
    }
    //this.procesos=[];
    //console.log(postData);
    this.authService.service("/api/mov_idx_pro",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);      
        //swal.fire('¡ok!', '', 'success');
        //this.update_raci();
        this.memoria();
        this.loading=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta! mov_idx', '', 'error');
          this.loading=false;
      });    
      this.loading=false;
  }
  mov_idx_dep(itm,t){
    this.t_memo="mov";
    this.ap_memo="area";
    this.id_dep=itm.id;
    this.lado=t;

    this.loading=true;
    let postData = {      
      lado:t,     
      id:itm.id
    }
    //this.procesos=[];
    //console.log(postData);
    this.authService.service("/api/mov_idx_dep",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);      
        //swal.fire('¡ok!', '', 'success');
        //this.update_raci();
        this.memoria();
        this.loading=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta! mov_idx', '', 'error');
          this.loading=false;
      });    
  }
  upd_pro(){
    let postData = {      
      proceso:this.pro_,
      descripcion:this.des_,
      valor:"",
      id:this.id_pro,
      raci:this.raciaux_
    }
    //this.procesos=[];
    //console.log(postData);
    this.t_memo="upd";
    this.ap_memo="pro";
    this.authService.service("/api/upd_proceso",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                      
        this.cpro.nativeElement.click();
        this.memoria();
        //this.update_raci();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      }); 
  }
  del_pro(){
    let postData = {      
      id:this.id_pro
    }
    
    this.t_memo="del";
    this.ap_memo="pro";
      //this.procesos=[];
    
      this.authService.service("/api/del_proceso",postData)
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                      
          this.memoria()
          this.cpro.nativeElement.click();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        }); 
    }
  raci_name;
  btn_racsi:boolean=false;
  v_raci(itm){
    this.bnd_list=false;
    this.btn_racsi=true;
    this.id_raci=itm.id;
    this.raci_name=itm.descipcion
    this.update_raci();    
   
  }
  update_raci(){
    this.ls_area();    
  }
  n_process(){
    this.des_="";
    this.vdel_pro=true;
    this.btn_pro=true;
    this.pro_="";
  }
  n_area(){
    this.vdel_area=true;
    this.btn_dep=true;
    this.dep_="";
  }
  raci:any;
  ls_raci(){
    this.rel_pa=[];
    let postData = {
    id_cliente:Number(this.id_cliente)}
    console.log(postData);
    this.authService.service("/api/get_services",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);             
        console.log(res);
        this.raci=res;
        this.sel_raci();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });  

}
del_area(itm){
  if(confirm("Confirm to delete this row?")==false)return;
  this.id_dep=itm.id;
  this.del_dep();  
}
org_id_=0;
del_proceso(itm){ 
  console.log("--");
  if(confirm("Confirm to delete this row?")==false)return;
  this.id_pro=itm.id;
  this.del_pro();  
}
  ls_pa(){
    this.rel_pa=[];
    let postData = {
      id_raci:this.id_raci
    }
    console.log(postData);
    this.authService.service("/api/get_pa_2",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);             
        for(var i=0;i<res.length;i++){
          //console.log(res[i]);         
          this.rel_pa.push(
              {id:res[i].id,
              id_p:res[i].id_tarea,
              id_a:res[i].id_area,
              rol:res[i].rol,
              c:"X"});
        }
        //console.log(res); 
        //this.load_rasci(); 
        //console.log(this.rel_pa);        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡Información incorrecta!', '', 'error');
      });  

}
public check_pa(p,a){
  
  for(var i=0;i<this.rel_pa.length;i++){
      if(this.rel_pa[i].id_p==p &&  this.rel_pa[i].id_a==a ){
        if(this.rel_pa[i].rol=='X'){
          //console.log(p+"-"+a +"--x")
            return "true";
        }
      }
  }
  //console.log(p+"-"+a +"")
  return false;
}
raci_="";
raci_id=0;
bndv_raci:boolean=true;
edt_raci(itm){
  this.bndv_raci=false;
  this.raci_id=itm.id;
  console.log(itm);
  this.raci_=itm.descipcion;
}
n_raci(){
  this.bndv_raci=true;
  this.raci_="";
}
upd_raci(){
  let postData = {
    id:this.raci_id,
    raci:this.raci_,
    org_id:this.org_id2
  }
  this.authService.service("/api/upd_raci",postData)
.then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);     
      this.ls_raci();
      this.craci.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}

gda_raci(){
  if(Number(this.org_id2)==-1){swal.fire('¡Información incompleta!', '', 'warning');return;}
  if(this.raci_==""){swal.fire('¡Información incompleta!', '', 'warning');return;}
  let postData = {
    id_cliente:this.id_cliente,
    raci:this.raci_,
    org_id:this.org_id2
  }
  
  console.log(postData);
  this.authService.service("/api/gda_raci_service",postData)
.then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);     
      this.ls_raci();
      this.org_id=this.org_id2;
      this.sel_raci();
      this.craci.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}
ls_proceso(){
  let postData = {
    id_raci:this.id_raci
  }
  this.procesos=[];
this.authService.service("/api/get_proceso",postData)
.then(
  data => {
    var dat = JSON.stringify(data);
    var res = JSON.parse(dat);  
    console.log(data);                    
    for(var i=0;i<res.length;i++){

      this.procesos.push( { valor_:res[i].valor_,valor:res[i].valor,
        id:res[i].id, 
        proceso:res[i].Titulo,
        descripcion:res[i].Descripcion,
        idx:res[i].idx,
        raci2:Number(res[i].id_raci2)}
      );
    }
    this.ls_pa();
  },
  error => {
      var de= JSON.stringify(error);
      var di = JSON.parse(de)
      swal.fire('¡Información incorrecta!', '', 'error');
  });  
}
ls_area(){
  let postData = {
    id_raci:this.id_raci
  }
  this.area=[];
  this.authService.service("/api/get_area",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);                        
      for(var i=0;i<res.length;i++){
        console.log(res[i]);
        var tx_area= "";
        if(res[i].id_ant==0){
          tx_area=res[i].area
        }else{
          if(res[i].role.toString()==""){
            tx_area=res[i].area;
          }else{
            tx_area=res[i].role;
          }
        }
        this.area.push({ 
          id:res[i].id,
          area:tx_area,
          idx:res[i].idx,
          id_ant:res[i].id_ant
        });        
      }
      this.ls_proceso();
      
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}

public type_raci:String;
a_:0;
p_:0;
nvo_reg1(a,p){
  //this.type_raci="";
  this.a_=a;
  this.p_=p;
}
bnd_list:Boolean=true;
togle_raci_list(){
  if(this.bnd_list==true){
    this.bnd_list=false
  }else{
    this.bnd_list=true;
  }
}
fmt_sr(t){
  localStorage.setItem("t_raci",t);
  localStorage.setItem("id_raci",this.id_raci.toString());
  this.router.navigate([]).then(result => {  window.open('./#/fmt3', '_blank'); });          
}
gdasa(_a_,_p_,v_){
  this.loading=true;
  var rol_="";
  if(v_==true){
   rol_="X"; 
  }

  let postData = {
    a_:_a_,
    p_:_p_,
    rol:rol_ 
  }
  console.log(postData);
  this.authService.service("/api/ins_pa",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);                        
      //this.update_raci();
      //this.cpa.nativeElement.click();
      this.loading=false;
      //swal.fire('ok!', '', 'success');
    },
    error => {
      this.loading=false;
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  

}
id_cliente:Number=0;
dep_:any;
pro_:any;
catalog_raci(){
  if(confirm("Confirm to create catalog from role card?")==false)return;
  let postData = {
    id_cliente:this.id_cliente,
    id_raci:this.id_raci,  
  }
  console.log(postData);
  this.authService.service("/api/ins_catalog_raci",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);   
      this.update_raci();   
      this.cper.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });   
}
del_raci(itm){
  if(confirm("Confirm to delete this record?")==false)return;
  let postData = {
    id:itm.id
  }
  console.log(postData);
  this.authService.service("/api/del_raci",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);   
      this.ls_raci();
      this.cper.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });   
}
clean_chars(c){

  if(c!=undefined){
    c=c.replace(/[']/g, "`");
  }else{
    return "";
  }
  return c;
}
t_memo="";
ap_memo="";
lado="";
dep_lado="";
dep_id=0;
gda_dep_lado(l){
  if (this.org_id_==0){
    if (this.dep_==undefined || this.dep_.length==0)return ;  
  }
  this.dep_=this.clean_chars(this.dep_);

  let postData = {
    id:this.id_dep,
    dep:this.dep_,
    org:Number(this.org_id_),
    lado:l
  }
  this.t_memo="ins_lado";
  this.ap_memo="area";
  this.lado=l;
  this.dep_lado=l;
  console.log(postData);
  this.authService.service("/api/ins_dep_lado2",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);  
      //this.ls_area();
      console.log(res[0][0].id);
      if(res[0][0].repetido==0){
        this.dep_id=res[0][0].id;  
        this.memoria();
        //console.log(this.nid_pro);
        console.log("se inserta");
      }else{
        //console.log(data);
        console.log("repetido")
      }
      
      

      this.cper.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}
memoria(){
  var aux=[];
  //console.log(this.t_memo);
  //console.log(this.ap_memo);
  switch (this.t_memo) {
    case "del":
      //////////////////////////////////////////////
        switch (this.ap_memo) {
          case "area":
            for(var i=0;i<this.area.length;i++){
              if(this.area[i].id!=this.id_dep){
                aux.push(this.area[i]);
              }
            }
            this.area=aux;   
            break;
          case "pro":            
            for(var i=0;i<this.procesos.length;i++){
              if(this.id_pro !=this.procesos[i].id){
                aux.push(this.procesos[i]);
              }  
            }
            this.procesos=aux;
          break;
        }
      break;
      //////////////////////////////////////////////
    case "ins":        
    //////////////////////////////////////////////
        switch (this.ap_memo) {
          case "area":
            var max_=0;
            for(var i=0;i<this.area.length;i++){
              if(max_ <this.area[i].idx){
                max_=this.area[i].idx;
              }
            }          
            if(this.org_id_>0)this.dep_=this.fn_nom_org(this.org_id_);
            this.area.push({id:this.dep_id, area:this.dep_,idx:max_,id_ant:this.org_id_});  
            break;          
          case "pro":
            var max_=0;
            for(var i=0;i<this.procesos.length;i++){
              if(max_ <this.procesos[i].idx){
                max_=this.procesos[i].idx;
              }
            }
            
            this.procesos.push({id:Number(this.id_pro),proceso:this.pro_,
              descripcion:this.des_=undefined?"":this.des_,
                idx:max_,valor:0,valor_:"",raci2:this.raciaux_})   
            break;
          }
    //////////////////////////////////////////////
    
      break;    
    case "ins_lado":
      switch (this.ap_memo) {
        case "pro":       
        //console.log("-inslado pro-");
        //console.log(this.lado);
          var aux=Array();            
          if(this.lado=="i"){
            for(var i=0;i<this.procesos.length;i++){                   
              if(this.id_pro==this.procesos[i].id){
                aux.push({id:Number(this.nid_pro),
                    proceso:this.pro_,
                    descripcion:this.des_=undefined?"":this.des_,
                    idx:0,
                    valor:0,valor_:"",raci2:this.raciaux_});      
                aux.push(this.procesos[i]);
              }else{
                aux.push(this.procesos[i]);                  
              }
            }
          }else if(this.lado=="d"){
            for(var i=0;i<this.procesos.length;i++){   
              if(this.id_pro==this.procesos[i].id){
                aux.push(this.procesos[i]);
                aux.push({id:Number(this.nid_pro),
                    proceso:this.pro_,
                    descripcion:this.des_=undefined?"":this.des_,
                    idx:0,
                    valor:0,valor_:""});                        
              }else{
                aux.push(this.procesos[i]);                  
              }
            }
          }
          this.procesos=aux;
          
        break;
        case "area":
          if(this.org_id_>0)this.dep_=this.fn_nom_org(this.org_id_);
          //this.area.push({ id:this.dep_id,area:this.dep_,idx:0,id_ant:this.org_id_}); 
          var aux=Array();            
          if(this.lado=="i"){
            for(var i=0;i<this.area.length;i++){                   
              if(this.id_dep==this.area[i].id){
                aux.push({ id:this.dep_id,area:this.dep_,idx:0,id_ant:this.org_id_}); 
                aux.push(this.area[i]);
              }else{
                aux.push(this.area[i]);                  
              }
            }
          }else if(this.lado=="d"){
            for(var i=0;i<this.area.length;i++){   
              if(this.id_dep==this.area[i].id){
                aux.push(this.area[i]);
                aux.push({ id:this.dep_id,area:this.dep_,idx:0,id_ant:this.org_id_}); 
              }else{
                aux.push(this.area[i]);                  
              }
            }
          }
          this.area=aux;
        break;          
      }
      break;
    case "upd":       
      switch (this.ap_memo) {
        case "area":
          /*
            dep:this.dep_,
            id:this.id_dep
          */
          for(var i=0;i<this.area.length;i++){
            if(this.id_dep==this.area[i].id){
              this.area[i].area=this.dep_;   
              if(this.area[i].id_ant>0)this.area[i].area=this.fn_nom_org(this.org_id_);
            }
          }
          break;
        case "pro":
          for(var i=0;i<this.procesos.length;i++){
            if(this.id_pro==this.procesos[i].id){
              this.procesos[i].descripcion=this.des_;
              this.procesos[i].proceso=this.pro_;    
              this.procesos[i].raci2=this.raciaux_;            
            }
          }
        break;
       
          var bnd=0;
          for(var i=0;i<this.rel_pa.length;i++){
            if(this.rel_pa[i].id_a==this.a_ && this.rel_pa[i].id_p==this.p_ ){
              bnd=1;
             //console.log( this.rel_pa[i]);
             //console.log("existe");
              this.rel_pa[i].rol=this.type_raci.toString();

            }
          }
          if(bnd==0){
            //console.log("nuevo");
             
          }
          break;
      }
    //////////////////////////////////////////////
    //////////////////////////////////////////////
      break; 
    
    case "mov":       
      var aux_id=0;
      var aux_idx=0;
      var bnd_id=0;
      var aux_proceso;
      switch (this.ap_memo) {
        case "pro":            
          if(this.lado=="i"){
            for(var i=0;i<this.procesos.length;i++){   
              if(this.id_pro==this.procesos[i].id){
                try {                    
                  if(i!=0){
                    aux_proceso=this.procesos[i];
                    this.procesos[i]=this.procesos[i-1];
                    this.procesos[i-1]=aux_proceso;
                  }
                } catch (error) {                    
                }              
              }            
            }
           }else if(this.lado=='d'){
             var bndd=0;
              for(var i=0;i<this.procesos.length;i++){  
                if(this.id_pro==this.procesos[i].id){                                          
                  if(i<(this.procesos.length-1)){ 
                    aux_id=i;
                    aux_proceso=this.procesos[i];
                    bndd=1; 
                  }
                }            
              } 
              if(bndd==1){
                this.procesos[aux_id]=this.procesos[aux_id+1];
                this.procesos[aux_id+1]=aux_proceso; 
              }
           }
          break;
        case "area":            
            if(this.lado=="i"){
              for(var i=0;i<this.area.length;i++){   
                //console.log(i);
                if(this.id_dep==this.area[i].id){   
                  try {
                    if(i!=0){
                      aux_proceso=this.area[i];                    
                      this.area[i]=this.area[i-1];
                      this.area[i-1]=aux_proceso; 
                    }
                  } catch (error) {                     
                  }                    
                }
              }    
             }else if(this.lado=='d'){
              var bndd=0
              for(var i=0;i<this.area.length;i++){   
                //console.log(i);
                //console.log(this.id_dep);
                //console.log(this.area[i])
                //console.log(this.area)
                if(this.id_dep==this.area[i].id){
                  aux_id=i;
                  aux_proceso=this.area[i];
                  bndd=1;   
                }            
              } 
              if(bndd==1){
                this.area[aux_id]=this.area[aux_id+1];
                this.area[aux_id+1]=aux_proceso; 
              }
              //console.log(this.area)                
             }             
            break;        
      }
    //////////////////////////////////////////////
    //////////////////////////////////////////////
      break;    
    default:        
      break;
  }
  
}
raciaux_=0;
nid_pro=0;
fn_nom_org(id_){
  console.log(id_);
  //console.log(this.org_);
  for(var i=0;i<this.org_.length;i++){
    if(this.org_[i].id_role==id_){
      return this.org_[i].role_card;
    }
  }
  return "";
}
gda_dep(){  
  this.t_memo="ins";
  this.ap_memo="area";  
  this.dep_=this.clean_chars(this.dep_);
  let postData = {
    id_cliente:this.id_cliente,
    id_raci:this.id_raci,
    dep:this.dep_,
    id_ant:this.org_id_
  }
  //console.log(postData);
  this.authService.service("/api/ins_dep",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);  
      this.dep_id=res.insertId;       
      this.memoria();
      this.cdep.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}
des_:any;
gda_pro_lado(l){
  if(this.pro_==undefined || this.pro_=="")return;
  this.pro_=this.clean_chars(this.pro_);
  this.des_=this.clean_chars(this.des_);
  let postData = {
    id:this.id_pro,
    lado:l,
    pro:this.pro_,
    des:this.des_,
    valor:"",
    raci:this.raciaux_
  }
  this.t_memo="ins_lado";
  this.ap_memo="pro";
  this.lado=l;
  console.log(postData);
  this.authService.service("/api/ins_pro_lado2",postData)
  .then(
    data => {
      
      
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);        
      //console.log(res);
      if(res[0][0].repetido==0){
        this.nid_pro=res[0][0].id;  
        this.memoria();
        //console.log(this.nid_pro);
        //console.log("se inserta");
      }else{
        //console.log(data);
        //console.log("repetido")
      }
      
      
      //this.update_raci();  
      this.cprol.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}
gda_pro(){
  if(this.pro_==undefined || this.pro_=="")return;
  let postData = {
    id_cliente:this.id_cliente,
    id_raci:this.id_raci,
    pro:this.pro_,
    des:this.des_=undefined?"":this.des_,
    valor:"",
    raci:this.raciaux_
  }
  console.log(postData);
  this.pro_=this.clean_chars(this.pro_);
  this.des_=this.clean_chars(this.des_);
  this.t_memo="ins";
  this.ap_memo="pro";
  this.authService.service("/api/ins_pro",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);  
      this.id_pro=res.insertId;
      this.memoria()
      //this.update_raci();  
      this.cpro.nativeElement.click();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('¡Información incorrecta!', '', 'error');
    });  
}

nvo_reg(r){
  
  this.type_raci=r;
  //console.log(this.type_raci);
}

get_value(i,j){
    for(let p=0;p<this.procesos.length;p++){
      for(let a=0;a<this.area.length;a++){ 
        //console.log(""+this.procesos[p].id+" " + this.area[a].id);
        var bnd=0;  
        var r_:any=[];
        for(let p_a=0;p_a<this.rel_pa.length;p_a++){
          if(this.rel_pa[p_a].id_a==this.area[a].id &&
             this.rel_pa[p_a].id_p==this.procesos[p].id){
              bnd=1;
              r_=this.rel_pa[p_a];
              //console.log(this.rel_pa[p_a].rol);
          }
          
        }
        if(bnd==1){
          if(p==i&&a==j){
            return r_;
          }
          
        }

      }

    }
    //console.log("nada");
    var aux= {id:0,id_p:i,id_a:j,rol:"",c:""};
    //this.rel_pa.push(aux);
    return aux;
  }
   j_ant:number=0;
  load_rasci(){
    console.log("raci");
    var matrix = new Array();
    var matrix_c = new Array();
    var rows = this.procesos.length;
    var cols = this.area.length;
    console.log(rows);
    console.log(cols);
    for (var j = 0; j < cols; j++)
      matrix_c[j] = "";
    for (var i = 0; i < rows; i++)
      matrix[i] = new Array(matrix_c);
      for (var i = 0; i < rows; i++){
        for (var j = 0; j < cols; j++){
          matrix[i][j]=this.get_value(i,j);   
          
            //console.log(j);
        }
      }
     console.log(matrix);
     
      for (var i = 0; i < rows; i++)
      for (var j = 0; j < cols; j++){
        //console.log(""+i+" " + j);
        if (i==(rows-1) && (matrix[i][j].rol=='R' || matrix[i][j].rol=='AR')   ){
          
            matrix[i][j].c="CR"
          
        } 
        if (i==0 && (matrix[i][j].rol=='R' || matrix[i][j].rol=='AR')){
          this.j_ant=j;
          //console.log("R" + this.j_ant);
        }else{
          if((matrix[i][j].rol=='R' || matrix[i][j].rol=='AR') ){

            //console.log("R"+this.j_ant);
            if(this.j_ant==j){

              matrix[i-1][j].c="CR";
            }else if(this.j_ant<j){
              if((this.j_ant-j)==1){
                //console.log("es igual");
              }else{
                  for(var x=this.j_ant;x<=j;x++){
                    if(matrix[i-1][x].id!=0){
                      matrix[i-1][x].c="CL";
                    }else{
                      //console.log("aqui 1");  
                      //console.log(j);  
                      //console.log(this.j_ant); 
                      if (x==j)
                      this.rel_pa.push({id:0,id_p:i,id_a:x+1,rol:"&nbsp;",c:"C4"});
                      else if((j-this.j_ant)==1)
                      this.rel_pa.push({id:0,id_p:i,id_a:x+1,rol:"&nbsp;",c:"C4"});
                      else
                      this.rel_pa.push({id:0,id_p:i,id_a:x+1,rol:"&nbsp;",c:"CL"});
                      //-----------------------
                    }
                  }
                  matrix[i-1][j].c="C4";
              }
              matrix[i-1][this.j_ant].c="CR2";
            }else{
              //console.log(j);
              //console.log(this.j_ant);
              if((j-this.j_ant)==1){
                //console.log("es igual");
              }else{
                for(var x=j;x<this.j_ant;x++){
                  if(matrix[i-1][x].id!=0){
                    matrix[i-1][x].c="CL";
                  }else{
                    //console.log("aqui 2");  
                    if (x==j)
                      this.rel_pa.push({id:0,id_p:i,id_a:x+1,rol:"&nbsp;",c:"C1"});
                    else if((this.j_ant-j)==1)
                    this.rel_pa.push({id:0,id_p:(i),id_a:x+1,rol:"&nbsp;",c:"C1"});
                    else
                    this.rel_pa.push({id:0,id_p:(i),id_a:x+1,rol:"&nbsp;",c:"CL"});
                    //-----------------------
                  } 
                  //console.log(x);
                }
                matrix[i-1][j].c="C1";
              }
              matrix[i-1][this.j_ant].c="CR1";
            }  
            this.j_ant=j;
          }
        }
          
      }
    
     console.log(matrix);
     //console.log(this.rel_pa);
  }

  

}
